export const USER_AUTH_TICKET = 'USER_AUTH_TICKET';